import React from 'react';
// import { Link } from 'react-router-dom';
import DatePicker from '../../common/input/date-picker/DatePicker';
import './PostJobStyle.scss';
import CustomModalView from '../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';
import QualificationModalView from './QualificationFormModal';
import { Table } from 'react-bootstrap';
import PostJobSuccessModalView from './PostJobSuccessModel';
import JoditEditor from 'jodit-react';

const PostJobView = (props) => {
  // if (localStorage.getItem("token")) {
  return (
    <>
      <section id="council-registration" className="innerpage_bg">
        <div className="postjob-inner-bg"></div>
        <div className="container">
          <div className="council-registration_wrapper individual-registration">
            <h4 className="cc-main_title--md">
              Post a <span className="highlighted">Job</span>
            </h4>

            <div className="registration-form_main">
              <div className="registration-form_wrapper">
                <form
                  id="individual-personal-details_form"
                  style={{ padding: '0 10px' }}
                >
                  <div className="form-group">
                    <label>
                      Job Title<sup>*</sup>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        props.handelData('title', e.target.value)
                      }
                      className="form-control"
                      placeholder="Write Job Title here"
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Job Description<sup>*</sup>
                    </label>
                    <JoditEditor
                      onChange={(newContent) => {
                        props.handelData('description', newContent);
                      }}
                    />
                    {/* <input type="text"  onChange={(e) => props.handelData('description', e.target.value)} className="form-control" placeholder="Write Job Description here" /> */}
                  </div>
                  <div className="form-group">
                    <label>
                      Contact Name<sup>*</sup>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        props.handelData('patient_name', e.target.value)
                      }
                      className="form-control"
                      placeholder="Patient Name"
                    />
                    <div className="form-error-msg-post">
                      {props.patient_name_validate}
                    </div>
                  </div>
                  <div className="form-group ">
                    <label>
                      Enter Your Post Code,Select Search Button<sup>*</sup>
                    </label>
                    <div className="row">
                      <div className=" col-sm-9 mb-10">
                        <input
                          type="text"
                          onChange={(e) =>
                            props.handelData('postcode', e.target.value)
                          }
                          className="form-control"
                          placeholder="Postcode here"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => props.getDataPostCode()}
                        className="btn btn-primary btn-sm mt-n3 col-sm-3"
                      >
                        search
                      </button>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      Select Address From the List After Entering Post Code
                      <sup>*</sup>
                    </label>
                    <select
                      id="inputcare"
                      className="form-control"
                      onChange={(e) =>
                        e.target.value &&
                        props.handelData('job_address', e.target.value)
                      }
                    >
                      {props.address_list && props.address_list.length == 0 ? (
                        <option value="">Enter the Postcode</option>
                      ) : (
                        <option value="">Select the address</option>
                      )}
                      {props.address_list &&
                        props.address_list.map((each, id) => (
                          <option value={each}>
                            {each.replace(', , ,', '')}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>
                      Phone Number<sup>*</sup>
                    </label>
                    <input
                      type="tel"
                      onChange={(e) =>
                        props.handelData('phone', e.target.value)
                      }
                      className="form-control"
                      minLength={9}
                      maxLength={10}
                      placeholder="Your Phone Number Here"
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      Employer Type<sup>*</sup>
                    </label>
                    <select
                      id="inputcare"
                      onChange={(e) =>
                        props.handelData('job_type_input', e.target.value)
                      }
                      className="form-control"
                    >
                      <option>Pick the Employer Type</option>
                      {props.job_type.map((job_type, index) => (
                        <option value={job_type}>{job_type}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>
                      Contract Type<sup>*</sup>
                    </label>
                    <select
                      id="inputcare"
                      onChange={(e) =>
                        props.handelData('contract_type_input', e.target.value)
                      }
                      className="form-control"
                    >
                      <option>Pick the Contract Type</option>
                      {props.contract_type.map((contract_type, index) => (
                        <option value={contract_type.id}>
                          {contract_type.type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <hr />
                  {props.start_date_list.map((start_date, index) => (
                    <div className="form-group">
                      {start_date == 'onemore' && (
                        <>
                          <label>Select Start Date and Shift Times</label>
                          <p>each row represents a shift</p>
                        </>
                      )}
                      {/* {start_date == "addmore" && 
                                    <label>Select Start Date</label>
                                    } */}

                      <div class="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select Start Date
                        </label>
                        <div className="col-sm-8 mb-6 input-group">
                          <DatePicker
                            id="date"
                            defaultValue={props.start_date}
                            minValue="today"
                            className="form-control"
                            handleLangChange={(date) =>
                              props.handelShift('start_date', date, props.index)
                            }
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select End Date
                        </label>
                        <div className="col-sm-8 mb-6 input-group">
                          <DatePicker
                            id="date"
                            defaultValue={props.end_date}
                            minValue={props.start_date}
                            className="form-control"
                            handleLangChange={(date) =>
                              props.handelShift('end_date', date, props.index)
                            }
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select Carer Type
                        </label>
                        <div class="col-sm-8 mb-6">
                          <select
                            value={props.start_carer_type}
                            id="inputcare"
                            onChange={(e) =>
                              props.handelShift(
                                'start_carer_type',
                                e.target.value,
                                index
                              )
                            }
                            className="form-control"
                            style={{
                              overflow: 'hidden',
                              whiteSpace: 'pre',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            <option>Care Type</option>
                            {props.carer_type.map((carer_type, index) =>
                              props.start_carer_type === carer_type.id ? (
                                <option selected value={carer_type.id}>
                                  {carer_type.type}
                                </option>
                              ) : (
                                <option value={carer_type.id}>
                                  {carer_type.type}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select Repeat Type
                        </label>
                        <div class="col-sm-8 mb-6">
                          <select
                            id="inputcare"
                            onChange={(e) =>
                              props.handelShift(
                                'start_repeate_type',
                                e.target.value,
                                index
                              )
                            }
                            className="form-control"
                            style={{
                              overflow: 'hidden',
                              whiteSpace: 'pre',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            <option value={''}>Repeats</option>
                            {props.repeate_list.map((repeate_list, index) =>
                              props.start_repeate_type === repeate_list ? (
                                <option selected value={repeate_list}>
                                  {repeate_list}
                                </option>
                              ) : (
                                <option value={repeate_list}>
                                  {repeate_list}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          for="shift-timing"
                          class="col-sm-4 col-form-label"
                        >
                          Select Shift
                        </label>
                        <div class="col-sm-8 mb-6">
                          <select
                            onChange={(e) =>
                              props.handelShift(
                                'shift-timing',
                                e.target.value,
                                index
                              )
                            }
                            className="form-control"
                          >
                            <option>Shifts</option>
                            {props.shift_select_timing.map(
                              (repeate_list, index) =>
                                props.shift_timing === repeate_list ? (
                                  <option selected value={repeate_list}>
                                    {repeate_list}
                                  </option>
                                ) : (
                                  <option value={repeate_list}>
                                    {repeate_list}
                                  </option>
                                )
                            )}
                          </select>
                          {/*<button type='button' onClick={(e)=> props.showShiftModal(e)}className="text-left form-control">
                                            //     Select Shift Timing
                                            // </button>
                                        */}
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select Start Time
                        </label>
                        <div class="col-sm-8 mb-6">
                          <input
                            placeholder="12:00 AM"
                            value={
                              props.start_in_date === ''
                                ? '00:00'
                                : props.start_in_date
                            }
                            id="time-picker"
                            onFocus={(e) => (e.target.type = 'time')}
                            onBlur={(e) => {
                              if (e.target.value == '') {
                                e.target.type = 'text';
                              }
                            }}
                            onClick={(e) =>
                              props.handelShift(
                                'start_in_date',
                                e.target.value,
                                props.index
                              )
                            }
                            onChange={(e) =>
                              props.handelShift(
                                'start_in_date',
                                e.target.value,
                                props.index
                              )
                            }
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select End Time
                        </label>
                        <div class="col-sm-8 mb-6">
                          <input
                            placeholder="12:00 AM"
                            value={
                              props.start_out_date === ''
                                ? '00:00'
                                : props.start_out_date
                            }
                            id="time-picker"
                            onFocus={(e) => (e.target.type = 'time')}
                            onBlur={(e) => {
                              if (e.target.value == '') {
                                e.target.type = 'text';
                              }
                            }}
                            onClick={(e) =>
                              props.handelShift(
                                'start_out_date',
                                e.target.value,
                                props.index
                              )
                            }
                            onChange={(e) =>
                              props.handelShift(
                                'start_out_date',
                                e.target.value,
                                props.index
                              )
                            }
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label for="start_date" class="col-sm-4 col-form-label">
                          Select Quantity{' '}
                        </label>
                        <div class="col-sm-8 mb-6">
                          <input
                            value={props.start_quantity}
                            onChange={(e) =>
                              props.handelShift(
                                'start_quantity',
                                e.target.value,
                                index
                              )
                            }
                            type="number"
                            min={1}
                            max={15}
                            maxLength={2}
                            placeholder="Maximum quantity 15"
                            className="form-control"
                            pattern="[0-9]"
                          />
                        </div>
                      </div>

                      <div
                        style={{ border: '1px solid gray' }}
                        className="form-group row     text-center"
                      >
                        <label className="text-center ml-3">
                          Please select the day of the week
                        </label>

                        <fieldset className="d-flex h5 mt-2    justify-content-around  w-100 checkbox-inline">
                          <label className="radio-inline ">MON</label>
                          <label className="radio-inline ">TUE</label>
                          <label className="radio-inline ml-1">WED</label>

                          <label className="radio-inline mr-2 ">THU</label>

                          <label className="radio-inline mr-2">FRI</label>
                          <label className="radio-inline ">SAT</label>
                          <label className="radio-inline ">SUN</label>
                        </fieldset>

                        <fieldset className="d-flex h5   justify-content-around  w-100 checkbox-inline">
                          {props.weeek_check_boxes.map((each, index) => (
                            <label className="radio-inline">
                              {' '}
                              &nbsp;
                              <br />
                              {each == true ? (
                                <input
                                  onClick={props.changeValue}
                                  checked
                                  type="checkbox"
                                  name="monday"
                                  id={index}
                                  className="checkbox"
                                  value="track"
                                />
                              ) : (
                                <input
                                  onClick={props.changeValue}
                                  type="checkbox"
                                  name="monday"
                                  id={index}
                                  className="checkbox"
                                  value="track"
                                />
                              )}
                            </label>
                          ))}
                          {/*
                                            <label className="radio-inline">
                                                <input onClick={changeValue} type="checkbox" name="monday" id="tract" className="checkbox" value="track" />
                                            &nbsp;&nbsp;&nbsp;</label>

                                             <label className="radio-inline">
                                                <input onClick={changeValue} type="checkbox" name="tuesday" id="tract" className="checkbox" value="track" />
                                            &nbsp;</label>

                                            <label className="radio-inline">
                                               <input onChange={changeValue} type="checkbox" name="wednesday" id="tract" className="checkbox" value="track" />
                                            &nbsp;&nbsp;&nbsp;</label>

                                            <label className="radio-inline">dfdgdffg
                                                <input onChange={(e) => changeValue(e)} type="checkbox" name="thursday" className="checkbox"  id="tract" value="track" />
                                            </label>


                                            <label className="radio-inline">
                                                <input onChange={(e) => changeValue(e)} type="checkbox" name="friday" className="checkbox" id="tract" value="track" />
                                            </label>


                                            <label className="radio-inline">
                                                <input onChange={(e) => changeValue(e)} type="checkbox" name="saturday" className="checkbox" id="tract" value="track" />
                                             &nbsp;&nbsp;</label>

                                            <label className="radio-inline">

                                                <input onChange={(e) => changeValue(e)} type="checkbox" name="sunday" className="checkbox" id="tract" value="track" />
                                             </label>

                                         */}
                        </fieldset>
                      </div>
                      <div className="form-group  text-right row">
                        <div className="text-left  w-75">
                          <label className="radio-inline ml-1">
                            <input
                              type="checkbox"
                              onClick={props.weekDaysOnly}
                              style={{ marginTop: '3px' }}
                              className="checkbox"
                              id="week_days"
                            />
                            &nbsp;Weekdays Only
                          </label>
                        </div>

                        <div className="text-right w-100 d-inline-block">
                          <br />
                          <button
                            type="button"
                            onClick={() => props.handelshiftData()}
                            className="btn btn-primary "
                          >
                            ADD{' '}
                            <i className="fa fa-plus" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                      <hr />
                      {/* 
                                    <Table striped size="sm" style={{width: '100%'}}>
                                      <tr>
                                        <th style={{width: '23%'}}>Care Type</th>
                                        <th style={{width: '20%'}}>Repeats</th>
                                        <th>Date and Time</th>

                                        <th>Qty</th>
                                        <th>Add</th>
                                      </tr>
                                      <tr>
                                        <td>
                                            <div className="form-group"  >
                                                <select   id="inputcare" onChange={(e) => props.handelShift('start_carer_type', e.target.value, index)} className="form-control" style={{overflow:"hidden",whiteSpace:"pre", textOverflow:"ellipsis"}}>
                                                    <option>Care Type</option>
                                                    {props.carer_type.map((carer_type, index) => (
                                                    <option value={carer_type.id}>{carer_type.type}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="form-group" >
                                                <select  id="inputcare" onChange={(e) => props.handelShift('start_repeate_type', e.target.value, index)} className="form-control" style={{overflow:"hidden",whiteSpace:"pre", textOverflow:"ellipsis"}}>
                                                    <option>Repeats</option>
                                                    {props.repeate_list.map((repeate_list, index) => (
                                                    <option value={repeate_list}>{repeate_list}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </td>
                                        
                                        <td style={{width:"150px"}}>
                                            <div className="input-group ">
                                                    <span className="input-group-addon"><i style={{fontSize:"30px",marginTop:"6px",marginLeft:"150%"}} aria-hidden="true" className="fa fa-calendar text-primary" onClick={(e) => {props.inOutModal(e); props.setIndex(index)} }></i></span>
                                            </div>
                                        </td>
                                        <td>
                                            <input onChange={(e) => props.handelShift('start_quantity', e.target.value, index)} type='text' style={{width: '100%',marginRight:"11px"}}/>
                                        </td>
                                        <td>
                                            <div className="datetime-buttun_group">
                                                <button onClick={() => props.handelshiftData()} type="button" className="btn btn-primary add-btn"><i className="fa fa-plus" aria-hidden="true"></i></button>
                                            </div>
                                        </td>
                                        
                                      </tr>

                                    </Table>
                                    */}
                    </div>
                  ))}
                  <div>
                    {console.log(props.shift_select_list)}
                    {props.shift_select_list.map((select, index) => (
                      <>
                        {console.log(select.start_string)}
                        {select.start_string !== undefined && (
                          <div className="datetime-button_group">
                            <>
                              <span className="input-group text-break small d-inline">
                                {' '}
                                {select.start_string}
                                <i
                                  style={{
                                    width: '25px',
                                    height: '25px',
                                    paddingTop: '5px',
                                    paddingLeft: '5px',
                                    textAlign: 'center',
                                  }}
                                  className="fa fa-minus btn btn-primary float-right"
                                  aria-hidden="true"
                                  onClick={() =>
                                    props.handleMinusData('startdate', index)
                                  }
                                ></i>
                              </span>
                            </>
                            <br />
                          </div>
                        )}

                        <br />
                      </>
                    ))}
                  </div>
                  <div className="form-group">
                    <label>
                      Qualification/Training<sup>*</sup>
                    </label>
                    <button
                      type="button"
                      onClick={(e) => props.showAvailablityModal(e)}
                      id="inputExperience"
                      className="text-left form-control"
                    >
                      Pick your Qualification/Training
                    </button>
                    <div className="form-error-msg-post">
                      {props.selected_qualification}
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      Experience<sup>*</sup>
                    </label>
                    <select
                      id="inputcare"
                      onChange={(e) =>
                        props.handelData('experience_input', e.target.value)
                      }
                      className="form-control"
                    >
                      <option>Pick the Experience</option>
                      {props.experience.map((ex_type, index) => (
                        <option value={ex_type.id}>{ex_type.type}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>
                      Renumeration<sup>*</sup>
                    </label>
                    <div class="input-group sm-12 ">
                      <div class="input-group-prepend">
                        <div class="input-group-text bg-white border-0">
                          {' '}
                          &#163;
                        </div>
                      </div>
                      <input
                        type="number"
                        onChange={(e) =>
                          props.handelData('renumerate', e.target.value)
                        }
                        className="form-control "
                        min={0}
                        placeholder=""
                        pattern="[0-9]"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      Perks/incentive<sup>*</sup>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        props.handelData('incentive', e.target.value)
                      }
                      className="form-control"
                      placeholder="Perks/incentive"
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Closing Date<sup>*</sup>
                    </label>
                    <div
                      id="close-datepicker"
                      className="input-group date"
                      data-date-format="dd-mm-yyyy"
                    >
                      {/* <input className="form-control" placeholder="Closing Date" /> */}
                      <DatePicker
                        className="form-control"
                        placeholder="Closing Date"
                        minValue="today"
                        handleLangChange={(date) =>
                          props.handleLangChange('close_date', date)
                        }
                      />
                      <span className="input-group-addon">
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>
                      Language Preference<sup>*</sup>
                    </label>
                    <select
                      id="inputlanguage"
                      onChange={(e) =>
                        props.handelData('language_input', e.target.value)
                      }
                      className="form-control"
                    >
                      <option selected>Select the language</option>
                      {props.language.map((language, index) => (
                        <option value={language.id}>{language.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group terms-description">
                    <div className="form-check">
                      <input
                        onChange={(e) =>
                          props.handelData('terms', e.target.checked)
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="invalidCheck2"
                      />

                      <label className="form-check-label" for="invalidCheck2">
                        I agree to the{' '}
                        <a href="">
                          TERMS & CONDITIONS.<sup>*</sup>
                        </a>
                      </label>
                    </div>
                  </div>
                  <div className="form-btn_group">
                    <button
                      type="button"
                      className="btn m-1 btn-border"
                      onClick={props.handelSummit}
                    >
                      Save{' '}
                      <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      onClick={props.handelSummit}
                      className="btn m-1 btn-red"
                    >
                      Submit{' '}
                      <i
                        className="fa fa-location-arrow"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
        custom_model={props.custom_model}
        modal_id={props.modal_id}
      />
      <QualificationModalView
        date={props.start_date}
        modal_boolean={props.modal_boolean}
        showAvailablityModal={props.showAvailablityModal}
        hideAvailablityModal={props.hideAvailablityModal}
        shift_select_list={props.qualification}
        availablitydada={props.availablitydada}
        SummitAvailablity={props.SummitAvailablity}
        selectAllHandler={props.selectAllHandler}
        qualification_list={props.qualification_list}
        select_all={props.select_all}
        all_training={props.all_training}
        allTrainingHandle={props.allTrainingHandle}
      />
      <PostJobSuccessModalView
        showSuccessModal={props.showSuccessModal}
        hideSuccessModal={props.hideSuccessModal}
        Success_modal_boolean={props.Success_modal_boolean}
        custom_model={props.custom_model}
        modal_id={props.modal_id}
      />
    </>
  );
  //      } else {
  //     return (
  //       <Navigate to="/login" />
  //     )
  //   }
};
export default PostJobView;
